<mat-toolbar color="primary">
  <div style="display: flex; align-items: center;">
    <button mat-icon-button (click)="toggleMenu()">
      <mat-icon>menu</mat-icon>
    </button>
    <div class="mcrit_title">
      GRENADA. <span style="font-weight: 300; opacity: 0.8;">Automotive Bridge</span>
    </div>
  </div>

  <span style="flex: 1 1 auto;"></span>

  <div class="user-info" [title]="'User: ' + userInfo.name">
    <mat-icon style="font-size: 20px; height: 20px; width: 20px;">account_circle</mat-icon>
    <h4>{{userInfo.name}}</h4>
  </div>
</mat-toolbar>

<mat-sidenav-container>
  <mat-sidenav #mainMenu mode="side">
    <authzone-side-menu></authzone-side-menu>
  </mat-sidenav>
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-container>